var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showData)?_c('div',{staticClass:"mt-4"},[_c('PieChartLegend',{attrs:{"labels":_vm.labels}}),_c('PieChart',{attrs:{"data":_vm.chartData,"options":_vm.options}})],1):_c('div',[_vm._v(" Geen data om te tonen ")])
}
var staticRenderFns = []

export { render, staticRenderFns }